import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StatusCheckbox from '../StatusCheckbox';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`

class StatusBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dropdownOpen: false, 
    };
  }

  getStatusTexts = () => {
    const { statuses } = this.props;
    return Object.keys(statuses).map((key, index) => {
      const item = statuses[key];
      return <StatusCheckbox key={`status-${index}`} value={item.value} text={item.text} />
    })
  }

  render() {
    return (
      <Container>
        {this.getStatusTexts()}
      </Container>
    );
  }
}

StatusBar.propTypes = {
  primary: PropTypes.string,
  statuses: PropTypes.object,
}

StatusBar.defaultProps = {

}

export default StatusBar;
